// extracted by mini-css-extract-plugin
export var brand = "_bj-9";
export var compact = "_bj-6";
export var extraSmall = "_bj-7";
export var icon = "_bj-0";
export var large = "_bj-4";
export var light = "_bj-1";
export var medium = "_bj-5";
export var outline = "_bj-b";
export var primaryDark = "_bj-a";
export var primaryLight = "_bj-8";
export var primaryModern = "_bj-c";
export var success = "_bj-2";
export var successSolid = "_bj-3";